import type { QueryKeyReturnType } from '@inflearn/codegen-wrapper';

import { API_ENDPOINT, useClientApiV1CategoryMainQuery } from '../../resources/@types/courseSchema';

interface UseClientV1CategoryMainQuery {
  options?: Parameters<typeof useClientApiV1CategoryMainQuery>[0]['options'];
}

export function useCategoryMainQuery({ options }: UseClientV1CategoryMainQuery) {
  return useClientApiV1CategoryMainQuery({
    queryKey: getCategoryMainQueryKey(),
    url: API_ENDPOINT.CLIENT_V1_CATEGORY_MAIN,
    options,
  });
}

export const getCategoryMainQueryKey = (): QueryKeyReturnType => [
  API_ENDPOINT.CLIENT_V1_CATEGORY_MAIN,
];
